import { isRequired } from 'Automations/nodeDefinitions/validation/validators'
import { allHandlesConnected } from 'Automations/nodeDefinitions/validation/nodeValidators'

export const actionTypeRequired = isRequired({
  title: 'Missing action type',
  message: 'Action node requires a type'
})

export const handlesConnected = allHandlesConnected({
  handleTypes: ['target', 'source'],
  title: 'Disconnected node',
  message: 'All handles must be connected'
})
